import { isNullOrUndefined } from '../utils/misc_utils';

//---------------------------------------------------------------------------------------------------------------------- environment

const ENVIRONMENT_DEVELOPMENT = 'development';
const ENVIRONMENT_TEST1 = 'test1';
const ENVIRONMENT_TEST2 = 'test2';
const ENVIRONMENT_PRODUCTION = 'production';

const getEnvironment = () => {
    if (isNullOrUndefined(process.env.REACT_APP_ENVIRONMENT)) {
        return ENVIRONMENT_DEVELOPMENT;
    }

    return process.env.REACT_APP_ENVIRONMENT.trim()
        .toLowerCase();
};

export const ENVIRONMENT = getEnvironment();

//---------------------------------------------------------------------------------------------------------------------- API

const API_BASE_URL_PRODUCTION = 'https://api.freshpod.pl';
const API_BASE_URL_TEST_1 = 'https://api.test1.freshpod.pl';
const API_BASE_URL_TEST_2 = 'https://api.test2.freshpod.pl';
const API_BASE_URL_DEVELOPMENT = API_BASE_URL_TEST_1;

const getApiRootUrl = () => {
    switch (ENVIRONMENT) {
        case ENVIRONMENT_DEVELOPMENT:
            return API_BASE_URL_DEVELOPMENT;
        case ENVIRONMENT_TEST1:
            return API_BASE_URL_TEST_1;
        case ENVIRONMENT_TEST2:
            return API_BASE_URL_TEST_2;
        case ENVIRONMENT_PRODUCTION:
        default:
            return API_BASE_URL_PRODUCTION;
    }
};

export const API_BASE_URL = getApiRootUrl();

export const API_AUTHORIZATION_HEADER = 'Authorization';
export const API_CONTENT_TYPE_HEADER = 'Content-Type';

//---------------------------------------------------------------------------------------------------------------------- API PATH's

// authorization module
export const TOKEN_PATH = '/auth/token';

// communication module
export const NOTIFICATIONS_PATH = '/communication/api/v1/web/notifications';
export const NOTIFICATION_TYPES_PATH = '/communication/api/v1/web/notifications/types';
export const DELIVERY_NOTIFICATIONS_PATH = '/communication/api/v1/web/delivery-notifications';

// customer module
export const CUSTOMER_PATH = '/customer/api/v1/web/customers';
export const CUSTOMER_ACTIVITIES_PATH = '/customer/api/v1/web/customer-activities';
export const CUSTOMER_BLOCKADE_REGISTRIES_PATH = '/customer/api/v1/web/customer-blockade-registries';
export const INCORRECT_EMAILS_PATH = '/customer/api/v1/web/incorrect-emails';

// inventory module
export const PRODUCT_BATCHES_PATH = '/inventory/api/v1/web/product-batches';
export const PRODUCT_DEFINITION_PATH = '/inventory/api/v1/web/products';
export const INVENTORIES_PATH = '/inventory/api/v1/web/inventories';
export const COUNTERPARTIES_PATH = '/inventory/api/v1/web/counterparties';
export const WAREHOUSE_DOCUMENTS_PATH = '/inventory/api/v1/web/documents';
export const FOOD_PARTNER_ORDER_PATH = '/inventory/api/v1/web/food-partner-orders';
export const WAREHOUSES_PATH = '/inventory/api/v1/web/warehouses';
export const DELIVERIES_PATH = '/inventory/api/v1/web/deliveries';
export const INVOICES_PATH = '/inventory/api/v1/web/invoices';

// pod module
export const DEVICES_PATH = '/pod/api/v1/web/devices';
export const PODS_PATH = '/pod/api/v1/web/pods';
export const INDOOR_PARTNERS_PATH = '/pod/api/v1/web/indoor-partners';
export const ADVERTISEMENTS_PATH = '/pod/api/v1/web/advertisements';
export const EVENT_REGISTERS_PATH = '/pod/api/v1/web/events-register';

// pop module
export const POPS_PATH = '/pop/api/v1/web/pops';
export const HUBS_PATH = '/pop/api/v1/web/hubs';

// price module
export const EXPIRATION_PROMOTIONS_PATH = '/price/api/v1/web/expiration-promotions';
export const PRODUCT_PROMOTIONS_PATH = '/price/api/v1/web/product-promotions';
export const EXPIRATION_PROMOTION_SETTINGS_PATH = '/price/api/v1/web/expiration-promotion-settings';
export const AUTOMATIC_EXPIRATION_PROMOTION_SETTINGS_PATH = '/price/api/v1/web/automatic-expiration-promotion-settings';
export const PRICES_PATH = '/price/api/v1/web/prices';
export const PROMOTION_CAMPAIGN_PATH = '/price/api/v1/web/promotion-campaigns';
export const POD_PRICE_ASSIGNMENT_PATH = '/price/api/v1/web/pod-price-assignments';
export const PRICE_LIST_PATH = '/price/api/v1/web/price-lists';
export const POD_PRICE_LIST_PATH = '/price/api/v1/web/pods';
export const ITEM_PRICE_LIST_PATH = '/price/api/v1/web/products';
export const STORE_PROMOTION_SETTINGS_PATH = '/price/api/v1/web/store-promotion-settings';
export const DEPOSITS_PATH = '/price/api/v1/web/deposits';
export const STORE_DISCOUNT_TYPES_PATH = '/price/api/v1/web/store-discount-types';
export const SALES_DATA_PATH = '/price/api/v1/web/sales-data';

// coupon module
export const COUPONS_PATH = '/coupon/api/v1/web/coupons';
export const AUTOMATIC_COUPON_SETTINGS_PATH = '/coupon/api/v1/web/automatic-coupon-settings';

// product module
export const PRODUCTS_PATH = '/product/api/v1/web/products';
export const LANGUAGES_PATH = '/product/api/v1/web/languages';
export const CONSTANTS_PATH = '/product/api/v1/web/constants';
export const PRODUCERS_PATH = '/product/api/v1/web/producers';
export const HEATING_PROGRAMS_PATH = '/product/api/v1/web/heating-programs';

// food partner module
export const FOOD_PARTNERS_PATH = '/food-partner/api/v1/web/food-partners';

// store module
export const BUSINESS_DATA_PATH = '/store/api/v1/web/business-data';
export const SUPPLIERS_PATH = '/store/api/v1/web/suppliers';

// benefit module
export const EMPLOYERS_PATH = '/benefit/api/v1/web/employers';
export const EMPLOYEES_PATH = '/benefit/api/v1/web/employee-emails';

// reservation module
export const RESERVATIONS_PATH = '/reservation/api/v1/web/reservations';
export const CUSTOMER_RESERVATIONS_PATH = '/reservation/api/v1/web/customers';
export const PRODUCTS_AVAILABILITY_PATH = '/reservation/api/v1/web/product-availabilities';
export const POD_RESERVATION_CONFIG_PATH = '/reservation/api/v1/web/pod-configs';
export const ARRANGEMENT_PATH = '/reservation/api/v1/web/arrangements';

// order module
export const CART_EVENTS_PATH = '/order/api/v1/web/cart-event';
export const THEFT_REGISTRIES_PATH = '/order/api/v1/web/theft-registries';
export const ORDERS_PATH = '/order/api/v1/web/orders';
export const RESERVATION_ORDERS = '/order/api/v1/web/reservation-orders';
export const STATS_PATH = '/order/api/v1/web/stats';

//---------------------------------------------------------------------------------------------------------------------- routes

export const ROUTE_SIGN_IN = '/logowanie';

export const ROUTE_PRODUCTS = '/produkty';
export const ROUTE_PRODUCT_FORMS = '/produkt/:productId';
export const ROUTE_PRODUCT_FORMS_NEW = '/produkt/dodaj';

export const GET_ROUTE_PRODUCT_FORMS = (productId) => {
    if (isNullOrUndefined(productId)) {
        return ROUTE_PRODUCTS;
    }

    return ROUTE_PRODUCT_FORMS.replace(':productId', productId);
};

export const ROUTE_PODS = '/punkty-sprzedazy';
export const ROUTE_PODS_NEW = '/punkty-sprzedazy/dodaj';
export const ROUTE_PODS_EDIT = '/punkty-sprzedazy/:podId';

export const GET_ROUTE_PODS_EDIT = (podId) => {
    if (isNullOrUndefined(podId)) {
        return ROUTE_PODS;
    }

    return ROUTE_PODS_EDIT.replace(':podId', podId);
};

export const ROUTE_POD_SALES_DISTRIBUTION = '/punkty-sprzedazy/:podId/rozklad-sprzedazy';

export const GET_ROUTE_POD_SALES_DISTRIBUTION = (podId) => {
    if (isNullOrUndefined(podId)) {
        return ROUTE_PODS;
    }

    return ROUTE_POD_SALES_DISTRIBUTION.replace(':podId', podId);
};

export const ROUTE_INDOOR_PARTNER_NEW = '/partnerzy-handlowi/dodaj';
export const ROUTE_INDOOR_PARTNER_EDIT = '/partnerzy-handlowi/:indoorPartnerId';

export const GET_ROUTE_INDOOR_PARTNER_EDIT = (indoorPartnerId) => {
    if (isNullOrUndefined(indoorPartnerId)) {
        return ROUTE_PODS;
    }

    return ROUTE_INDOOR_PARTNER_EDIT.replace(':indoorPartnerId', indoorPartnerId);
};

export const ROUTE_EVENT_REGISTER_NEW = '/rejestr-zdarzen/dodaj';

export const ROUTE_PRODUCERS = '/producenci';
export const ROUTE_PRODUCER_FORMS = '/producenci/:producerId';
export const ROUTE_PRODUCER_FORMS_NEW = '/producenci/dodaj';

export const GET_ROUTE_PRODUCER_FORMS = (producerId) => {
    if (isNullOrUndefined(producerId)) {
        return ROUTE_PRODUCERS;
    }

    return ROUTE_PRODUCER_FORMS.replace(':producerId', producerId);
};

export const ROUTE_FOOD_PARTNERS = '/dostawcy';
export const ROUTE_FOOD_PARTNER_FORMS = '/dostawcy/:foodPartnerId';
export const ROUTE_FOOD_PARTNER_FORMS_NEW = '/dostawcy/dodaj';

export const GET_ROUTE_FOOD_PARTNER_FORMS = (foodPartnerId) => {
    if (isNullOrUndefined(foodPartnerId)) {
        return ROUTE_FOOD_PARTNERS;
    }

    return ROUTE_FOOD_PARTNER_FORMS.replace(':foodPartnerId', foodPartnerId);
};

export const ROUTE_EMPLOYERS = '/pracodawcy';
export const ROUTE_EMPLOYER = '/pracodawca/:employerId';

export const GET_ROUTE_EMPLOYER = (employerId) => {
    if (isNullOrUndefined(employerId)) {
        return ROUTE_EMPLOYERS;
    }

    return ROUTE_EMPLOYER.replace(':employerId', employerId);
};

export const ROUTE_SUPPLIERS = '/zaopatrzeniowcy';
export const ROUTE_SUPPLIERS_NEW = '/zaopatrzeniowcy/dodaj';
export const ROUTE_SUPPLIERS_EDIT = '/zaopatrzeniowcy/:supplierId';

export const GET_ROUTE_SUPPLIERS_EDIT = (supplierId) => {
    if (isNullOrUndefined(supplierId)) {
        return ROUTE_SUPPLIERS;
    }

    return ROUTE_SUPPLIERS_EDIT.replace(':supplierId', supplierId);
};

export const ROUTE_CUSTOMERS = '/klienci';
export const ROUTE_CUSTOMER = '/klienci/:customerId';
export const ROUTE_CUSTOMER_THEFT_REGISTRY_NEW = '/klienci/:customerId/kartoteka/dodaj';
export const ROUTE_CUSTOMER_THEFT_REGISTRY_VIEW = '/klienci/:customerId/kartoteka/:theftRegistryId';
export const ROUTE_CUSTOMER_POD_ORDER_NEW = '/klienci/:customerId/zakupy-stacjonarne/dodaj';

export const GET_ROUTE_CUSTOMER = (customerId) => {
    if (isNullOrUndefined(customerId)) {
        return ROUTE_CUSTOMERS;
    }

    return ROUTE_CUSTOMER.replace(':customerId', customerId);
};

export const GET_ROUTE_CUSTOMER_THEFT_REGISTRY_NEW = (customerId) => {
    if (isNullOrUndefined(customerId)) {
        return ROUTE_CUSTOMERS;
    }

    return ROUTE_CUSTOMER_THEFT_REGISTRY_NEW.replace(':customerId', customerId);
};

export const GET_ROUTE_CUSTOMER_POD_ORDER_NEW = (customerId) => {
    if (isNullOrUndefined(customerId)) {
        return ROUTE_CUSTOMERS;
    }

    return ROUTE_CUSTOMER_POD_ORDER_NEW.replace(':customerId', customerId);
};

export const GET_CUSTOMER_THEFT_REGISTRY = (customerId, theftRegistryId) => {
    if (isNullOrUndefined(customerId) || isNullOrUndefined(theftRegistryId)) {
        return ROUTE_CUSTOMERS;
    }

    return ROUTE_CUSTOMER_THEFT_REGISTRY_VIEW
        .replace(':customerId', customerId)
        .replace(':theftRegistryId', theftRegistryId);
};

export const ROUTE_THEFT_REGISTRIES = '/kradzieze';

export const ROUTE_INCORRECT_EMAILS = '/nieprawidlowe-adresy-email';

export const ROUTE_SALES_ANALYSIS = '/analiza-sprzedazy';

// previous addresses of the pod sales distribution page, kept as redirects for bookmarks
export const ROUTE_LEGACY_SALES = '/sprzedaz';
export const ROUTE_LEGACY_POD_SALES = '/sprzedaz/:podId';

export const ROUTE_PRODUCT_PROMOTIONS = '/promocje-produtkowe';
export const ROUTE_PRODUCT_PROMOTIONS_DETAILS = '/promocje-produtkowe/:productId';

export const GET_ROUTE_PRODUCT_PROMOTIONS_DETAILS = (productId) => {
    if (isNullOrUndefined(productId)) {
        return ROUTE_PRODUCT_PROMOTIONS;
    }

    return ROUTE_PRODUCT_PROMOTIONS_DETAILS.replace(':productId', productId);
};

export const ROUTE_EXPIRATION_PROMOTIONS = '/promocje-krotka-data-przydatnosci';
export const ROUTE_EXPIRATION_PROMOTIONS_DETAILS = '/promocje-krotka-data-przydatnosci/:productId';

export const GET_ROUTE_EXPIRATION_PROMOTIONS_DETAILS = (productId) => {
    if (isNullOrUndefined(productId)) {
        return ROUTE_EXPIRATION_PROMOTIONS;
    }

    return ROUTE_EXPIRATION_PROMOTIONS_DETAILS.replace(':productId', productId);
};

export const ROUTE_AUTOMATIC_EXPIRATION_PROMOTION_SETTING_FORMS = '/ustawienia-automatycznych-promocji-na-krotka-date-przydatnosci/:id';

export const GET_ROUTE_AUTOMATIC_EXPIRATION_PROMOTION_SETTING_FORMS = (id) => {
    if (isNullOrUndefined(id)) {
        return ROUTE_EXPIRATION_PROMOTIONS;
    }

    return ROUTE_AUTOMATIC_EXPIRATION_PROMOTION_SETTING_FORMS.replace(':id', id);
};

export const ROUTE_STORE_PROMOTION_SETTINGS = '/ustawienia-promocji-sklepowych';

export const ROUTE_PROMOTION_CAMPAIGNS = '/akcje-promocyjne';
export const ROUTE_PROMOTION_CAMPAIGNS_FORMS = '/akcje-promocyjne/:promotionCampaignId';
export const ROUTE_PROMOTION_CAMPAIGNS_FORMS_NEW = '/akcje-promocyjne/dodaj';

export const GET_ROUTE_PROMOTION_CAMPAIGNS_FORMS = (promotionCampaignId) => {
    if (isNullOrUndefined(promotionCampaignId)) {
        return ROUTE_PROMOTION_CAMPAIGNS_FORMS;
    }

    return ROUTE_PROMOTION_CAMPAIGNS_FORMS.replace(':promotionCampaignId', promotionCampaignId);
};

export const ROUTE_NOTIFICATIONS = '/powiadomienia';
export const ROUTE_NOTIFICATIONS_NEW = '/powiadomienia/dodaj';

export const ROUTE_PRICE_LISTS = '/cennik';
export const ROUTE_PRICE_LISTS_NEW = '/cennik/dodaj';
export const ROUTE_PRICE_LISTS_EDIT = '/cennik/edytuj/:priceListId';
export const ROUTE_PRICE_LIST = '/cennik/:priceListId';

export const GET_ROUTE_PRICE_LISTS_EDIT = (priceListId) => {
    if (isNullOrUndefined(priceListId)) {
        return ROUTE_PRICE_LISTS;
    }

    return ROUTE_PRICE_LISTS_EDIT.replace(':priceListId', priceListId);
};

export const GET_ROUTE_PRICE_LIST = (priceListId) => {
    if (isNullOrUndefined(priceListId)) {
        return ROUTE_PRICE_LISTS;
    }

    return ROUTE_PRICE_LIST.replace(':priceListId', priceListId);
};

export const ROUTE_COUPONS = '/kupony';
export const ROUTE_COUPON_FORMS = '/kupon/:couponId';
export const ROUTE_COUPON_FORMS_NEW = '/kupon/dodaj';

export const GET_ROUTE_COUPON_FORMS = (couponId) => {
    if (isNullOrUndefined(couponId)) {
        return ROUTE_COUPONS;
    }

    return ROUTE_COUPON_FORMS.replace(':couponId', couponId);
};

export const ROUTE_AUTOMATIC_COUPON_SETTING_FORMS = '/ustawienia-automatycznych-kuponow/:automaticCouponType';

export const GET_ROUTE_AUTOMATIC_COUPON_SETTING_FORMS = (automaticCouponType) => {
    if (isNullOrUndefined(automaticCouponType)) {
        return ROUTE_COUPONS;
    }

    return ROUTE_AUTOMATIC_COUPON_SETTING_FORMS.replace(':automaticCouponType', automaticCouponType);
};

export const ROUTE_ADVERTISEMENTS = '/reklamy';
export const ROUTE_POD_ADVERTISEMENTS = '/reklamy/:podId';

export const GET_ROUTE_POD_ADVERTISEMENTS = (podId) => {
    if (isNullOrUndefined(podId)) {
        return ROUTE_ADVERTISEMENTS;
    }

    return ROUTE_POD_ADVERTISEMENTS.replace(':podId', podId);
};

export const ROUTE_RESERVATIONS = '/rezerwacje';

export const ROUTE_WAREHOUSE_DOCUMENTS = '/dokumenty-magazynowe';
export const ROUTE_WAREHOUSE_DOCUMENT_FORM = '/dokumenty-magazynowe/dodaj';
export const ROUTE_WAREHOUSE_DOCUMENT_VIEW = '/dokumenty-magazynowe/:warehouseDocumentId';

export const GET_ROUTE_WAREHOUSE_DOCUMENT = (warehouseDocumentId) => {
    if (isNullOrUndefined(warehouseDocumentId)) {
        return ROUTE_WAREHOUSE_DOCUMENTS;
    }

    return ROUTE_WAREHOUSE_DOCUMENT_VIEW.replace(':warehouseDocumentId', warehouseDocumentId);
};

export const ROUTE_FOOD_PARTNER_ORDERS = '/zamowienia-od-dostawcow';
export const ROUTE_FOOD_PARTNER_ORDERS_NEW = '/zamowienia-od-dostawcow/dodaj';
export const ROUTE_FOOD_PARTNER_ORDERS_EDIT = '/zamowienia-od-dostawcow/edytuj/:foodPartnerOrderId';
export const ROUTE_FOOD_PARTNER_ORDERS_VIEW = '/zamowienia-od-dostawcow/:foodPartnerOrderId';

export const GET_ROUTE_FOOD_PARTNER_ORDER_EDIT = (foodPartnerOrderId) => {
    if (isNullOrUndefined(foodPartnerOrderId)) {
        return ROUTE_FOOD_PARTNER_ORDERS;
    }

    return ROUTE_FOOD_PARTNER_ORDERS_EDIT.replace(':foodPartnerOrderId', foodPartnerOrderId);
};

export const ROUTE_WAREHOUSE_REPORTS = '/raporty-magazynowe';

export const ROUTE_WAREHOUSE_STOCKS = '/stany-magazynowe';
export const ROUTE_WAREHOUSE_STOCK = '/stany-magazynowe/:warehouseId';

export const GET_ROUTE_WAREHOUSE_STOCK = (warehouseId) => {
    if (isNullOrUndefined(warehouseId)) {
        return ROUTE_WAREHOUSE_STOCKS;
    }

    return ROUTE_WAREHOUSE_STOCK.replace(':warehouseId', warehouseId);
};

export const GET_ROUTE_FOOD_PARTNER_ORDER = (foodPartnerOrderId) => {
    if (isNullOrUndefined(foodPartnerOrderId)) {
        return ROUTE_FOOD_PARTNER_ORDERS;
    }

    return ROUTE_FOOD_PARTNER_ORDERS_VIEW.replace(':foodPartnerOrderId', foodPartnerOrderId);
};

export const ROUTE_DELIVERY_NOTIFICATIONS = '/powiadomienia-dostaw';
export const ROUTE_DELIVERY_NOTIFICATIONS_NEW = '/powiadomienia-dostaw/dodaj';
export const ROUTE_DELIVERY_NOTIFICATIONS_EDIT = '/powiadomienia-dostaw/:deliveryNotificationId';

export const GET_ROUTE_ROUTE_DELIVERY_NOTIFICATIONS_EDIT = (deliveryNotificationId) => {
    if (isNullOrUndefined(deliveryNotificationId)) {
        return ROUTE_DELIVERY_NOTIFICATIONS;
    }

    return ROUTE_DELIVERY_NOTIFICATIONS_EDIT.replace(':deliveryNotificationId', deliveryNotificationId);
};

//---------------------------------------------------------------------------------------------------------------------- misc

// configuration related
export const MISC_STORAGE_ENGINE_NAME = 'store-web-app';

// date related
export const MISC_DATE_ISO_DATE_ONLY_FORMAT = 'YYYY-MM-DD';
export const MISC_DATE_ISO_TIME_ONLY_FORMAT = 'HH:mm:ss';
export const MISC_DATE_ISO_FORMAT = MISC_DATE_ISO_DATE_ONLY_FORMAT + 'T' + MISC_DATE_ISO_TIME_ONLY_FORMAT;
export const MISC_DATE_POLISH_FORMAT = 'DD.MM.YYYY HH:mm:ss';
export const MISC_DATE_POLISH_DATE_ONLY_FORMAT = 'DD.MM.YYYY';

// rest
export const MISC_REST_CONTENT_TYPE_APPLICATION_JSON = 'application/json';
export const MISC_REST_CONTENT_TYPE_MULTIPART = 'multipart/form-data';
export const MISC_REST_CONTENT_TYPE_URLENCODED = 'application/x-www-form-urlencoded';
